
app.mapsController = app.mapsController || {};
app.mapsController.defaultAction = {

    init : function () {
        var rootF = this;
        if($('#contactMap').length > 0) {
            this.initMap();
        }
    },

    initMap : function () {
        var myLatlng = new google.maps.LatLng(49.242216, 1.171457);
        var myOptions = {
            disableDefaultUI: true,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL
            },
            draggable: $('html').hasClass('no-touch'),
            scrollwheel: false,
            zoom: 10,
            center: myLatlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        var map = new google.maps.Map(document.getElementById('contactMap'), myOptions);
        var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: "Yeska : Rue de la Coulée Verte<br>P.A de la Fringale<br>27000 Val de Reuil<br>02 32 09 57 80",
            icon:'/content/themes/yeska/img/marker.png'
        });
    }

};

$(document).ready(function(){
    app.mapsController.defaultAction.init();
});
